/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";

import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

function Author({ image, name, email }) {
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="sm" variant="full" />
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="button" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

const authorsTableData = {
  columns: [
    { name: "Tutor", align: "left" },
    { name: "Mobile No.", align: "center" },
    { name: "Age", align: "center" },
    { name: "Distance", align: "center" },
    { name: "Badge", align: "center" },
    { name: "Per Hour", align: "center" },
  ],

  rows: [
    {
      Tutor: <Author image={team2} name="Rahul Sharma" email="rahul@example.com" />,
      "Mobile No.": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          9876543210
        </ArgonTypography>
      ),
      Age: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          28
        </ArgonTypography>
      ),
      Distance: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          2.5 km
        </ArgonTypography>
      ),
      Badge: (
        <ArgonBadge
          variant="gradient"
          badgeContent="��� Level 3"
          color="success"
          size="xs"
          container
        />
      ),
      "Per Hour": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          ₹500
        </ArgonTypography>
      ),
    },
    {
      Tutor: <Author image={team3} name="Priya Patel" email="priya@example.com" />,
      "Mobile No.": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          9123456789
        </ArgonTypography>
      ),
      Age: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          25
        </ArgonTypography>
      ),
      Distance: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          1.8 km
        </ArgonTypography>
      ),
      Badge: (
        <ArgonBadge
          variant="gradient"
          badgeContent="��� Level 2"
          color="warning"
          size="xs"
          container
        />
      ),
      "Per Hour": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          ₹450
        </ArgonTypography>
      ),
    },
    {
      Tutor: <Author image={team4} name="Amit Kumar" email="amit@example.com" />,
      "Mobile No.": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          9988776655
        </ArgonTypography>
      ),
      Age: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          32
        </ArgonTypography>
      ),
      Distance: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          3.2 km
        </ArgonTypography>
      ),
      Badge: (
        <ArgonBadge
          variant="gradient"
          badgeContent="��� Level 4"
          color="info"
          size="xs"
          container
        />
      ),
      "Per Hour": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          ₹600
        </ArgonTypography>
      ),
    },
    {
      Tutor: <Author image={team2} name="Sneha Gupta" email="sneha@example.com" />,
      "Mobile No.": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          8765432109
        </ArgonTypography>
      ),
      Age: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          26
        </ArgonTypography>
      ),
      Distance: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          4.1 km
        </ArgonTypography>
      ),
      Badge: (
        <ArgonBadge
          variant="gradient"
          badgeContent="��� Level 1"
          color="error"
          size="xs"
          container
        />
      ),
      "Per Hour": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          ₹400
        </ArgonTypography>
      ),
    },
    {
      Tutor: <Author image={team3} name="Vikram Singh" email="vikram@example.com" />,
      "Mobile No.": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          7654321098
        </ArgonTypography>
      ),
      Age: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          30
        </ArgonTypography>
      ),
      Distance: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          2.9 km
        </ArgonTypography>
      ),
      Badge: (
        <ArgonBadge
          variant="gradient"
          badgeContent="��� Level 3"
          color="success"
          size="xs"
          container
        />
      ),
      "Per Hour": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          ₹550
        </ArgonTypography>
      ),
    },
  ],
};

export default authorsTableData;
